import { render, staticRenderFns } from "./Fault.vue?vue&type=template&id=1c2ea447&scoped=true"
import script from "./Fault.vue?vue&type=script&lang=js"
export * from "./Fault.vue?vue&type=script&lang=js"
import style0 from "./Fault.vue?vue&type=style&index=0&id=1c2ea447&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1c2ea447",
  null
  
)

export default component.exports